export default {
	namespaced: true,
	state: {
		selectedOrganization: null,
		selectedLocation: null,
		ecpLocations: null,
		pccSelectedLocation: null,
	},
	mutations: {
		SELECTED_ORGANIZATION (state, payload) {
			state.selectedOrganization = payload;
		},
		SELECTED_LOCATION (state, payload) {
			state.selectedLocation = payload;
		},
		SET_ECP_LOCATIONS (state, payload) {
			state.ecpLocations = payload;
		},
		SET_SELECTED_PCC_LOCATIONS (state, payload) {
			state.pccSelectedLocation = payload;
		},
	},
	actions: {},
	getters: {
		getSelectedOrganization (state) {
			return state.selectedOrganization;
		},
		getSelectedLocation (state) {
			return state.selectedLocation;
		},
		getEcpLocation (state) {
			return state.ecpLocations;
		},
		getPccSelectedLocation (state) {
			return state.pccSelectedLocation;
		},
	},
};
